import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

import { EmployeeModel } from '../../../model/index';
import { EmployeeService } from '../../../services/index';
import { AddEditEmployeeComponent } from './addEditEmployee.component';

@Component({
    selector: 'employee-tab',
    templateUrl: './employee.component.html',
})
export class EmployeeMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;



    public mode: string;
    public list: any[] = [];
    public employeedata: any[] = [];

    isLoadMask: Promise<any>;
    employeeData: EmployeeModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    constructor(private employeeService: EmployeeService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'empcode',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];


    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'EMPLOYEE CODE', prop: 'empcode', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'EMPLOYEE NAME', prop: 'empname', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'GENDER', prop: 'gender', width: 90, minWidth: 90, maxWidth: 90 },
            { name: 'FATHER/GUARDIAN', prop: 'fatherguardianname', width: 185, minWidth: 185, maxWidth: 185 },
            { name: 'RELATION', prop: 'relation', width: 95, minWidth: 95, maxWidth: 95 },
            { name: 'CONTACT', prop: 'contactno', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'DATE OF BIRTH', prop: 'dob', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'DATE OF JOINING', prop: 'dateeffrom', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'STATUS', prop: 'status', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'ACTION', prop: 'actions', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-center', sortable: false, cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getEmployeeList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    /**
   * Called whenever the user changes the sort order
   */
    /*     sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
            // there will always be one "sort" object if "sortType" is set to "single"
            this.page.orderDir = sortInfo.sorts[0].dir;
            this.page.orderBy = sortInfo.sorts[0].prop;
            this.getEmployeeList();
        } */
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getEmployeeList();
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getEmployeeList();
    }
    getEmployeeList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.employeeService
            .getEmployeeList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.employeeData = res.data;
            });
    }

    downloadCurrentData(): void {
        let params = {
            start: '0', limit: '99999',
            orderColumn: `${this.page.orderBy}`, orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        this.employeeService.getEmployeeList(params).then((res: any) => {
            const rows = (res.data || []).map((r, i) => ({
                'SNo': i + 1,
                'EMPLOYEE CODE': r.empcode,
                'EMPLOYEE NAME': r.empname,
                'GENDER': r.gender,
                'FATHER/GUARDIAN': r.fatherguardianname,
                'RELATION': r.relation,
                'CONTACT': r.contactno,
                'DATE OF BIRTH': r.dob,
                'DATE OF JOINING': r.dateeffrom,
                'STATUS': r.status
            }));
            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, 'Employee_' + moment().format('DD-MM-YYYY') + '.xlsx');
        });
    }

    onAddEmployee(): void {
        let that = this;
        let bsModalRef: BsModalRef = this.modalService.show(AddEditEmployeeComponent, {
            class: 'modal-lg',
            backdrop: 'static',
            keyboard: false,
            ignoreBackdropClick: true
        });
        bsModalRef.content.title = 'Add Employee';
        bsModalRef.content.employeedata = {
            mode: 'Add',
            gender: 'MALE',
            maritalstatus: 'SINGLE',
            status: 'Active'
        };
        bsModalRef.content.employeeLoadEvent.subscribe(() => {
            that.getEmployeeList();
        });
    }

    onEditEmployee(row: any): void {
        let that = this;
        let bsModalRef: BsModalRef = this.modalService.show(AddEditEmployeeComponent, {
            class: 'modal-lg',
            backdrop: 'static',
            keyboard: false,
            ignoreBackdropClick: true
        });
        bsModalRef.content.title = 'Edit Employee';
        bsModalRef.content.employeedata = Object.assign({}, row);
        bsModalRef.content.employeedata.mode = 'Edit';
        bsModalRef.content.employeeLoadEvent.subscribe(() => {
            that.getEmployeeList();
        });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/employee/employee.component.ts